 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account":"account","course~dashboard":"course~dashboard","course":"course","dashboard":"dashboard","memoryiq":"memoryiq","memogenius-game":"memogenius-game","memolanguage":"memolanguage"}[chunkId]||chunkId) + "-legacy." + {"account":"e3b37b9a","chunk-02501173":"1e5a067a","chunk-13581f54":"5de137c0","chunk-4dfc6d90":"f2804901","chunk-2d0ae5a4":"616ea36b","chunk-35f28bd1":"9d34d101","chunk-655795ce":"bee8998f","chunk-74916e7f":"21c032b1","chunk-327be9c0":"cc371aa5","chunk-53ce57c0":"370066a4","course~dashboard":"33c38907","course":"173d9a46","chunk-9dfabe94":"5d931653","dashboard":"6d714f73","chunk-531a3eec":"46934d27","chunk-5789a9c2":"246c5954","memoryiq":"49779d19","chunk-86ddfb4c":"72d89176","chunk-1cc39b1f":"d614bbcb","chunk-29b78bf5":"ff2160e5","chunk-686a04d2":"ec828981","chunk-9c20f2bc":"3762db53","chunk-6131bf73":"adb9b751","chunk-eb9edea8":"c2787b18","chunk-e66db300":"f9234e31","chunk-063a8ca1":"8225dfe4","chunk-6891f6f2":"3f4ecc2b","chunk-358c8e9a":"49cf81f2","memogenius-game":"56cd9e1e","chunk-6fa7f4cb":"e8dbb159","chunk-c030d618":"56782c94","chunk-dc5169ec":"9b68d053","chunk-ecb8ebc4":"fa28b7f8","memolanguage":"91b01875","chunk-3bc3fc3d":"2f7ea2e2","chunk-4f8cba5a":"58eafc24","chunk-04c4f904":"35a513b3","chunk-6d7f4e65":"ad847e09","chunk-a9a10d60":"dfe5c043","chunk-fa134ff0":"badd25ca","chunk-3b991abb":"46f18840"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account":1,"chunk-02501173":1,"chunk-13581f54":1,"chunk-4dfc6d90":1,"chunk-35f28bd1":1,"chunk-655795ce":1,"chunk-74916e7f":1,"chunk-327be9c0":1,"chunk-53ce57c0":1,"course~dashboard":1,"course":1,"chunk-9dfabe94":1,"dashboard":1,"chunk-531a3eec":1,"memoryiq":1,"chunk-1cc39b1f":1,"chunk-29b78bf5":1,"chunk-686a04d2":1,"chunk-9c20f2bc":1,"chunk-6131bf73":1,"chunk-eb9edea8":1,"chunk-e66db300":1,"chunk-063a8ca1":1,"chunk-6891f6f2":1,"chunk-358c8e9a":1,"memogenius-game":1,"chunk-6fa7f4cb":1,"chunk-c030d618":1,"chunk-dc5169ec":1,"chunk-ecb8ebc4":1,"memolanguage":1,"chunk-3bc3fc3d":1,"chunk-4f8cba5a":1,"chunk-04c4f904":1,"chunk-6d7f4e65":1,"chunk-a9a10d60":1,"chunk-fa134ff0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account":"account","course~dashboard":"course~dashboard","course":"course","dashboard":"dashboard","memoryiq":"memoryiq","memogenius-game":"memogenius-game","memolanguage":"memolanguage"}[chunkId]||chunkId) + "." + {"account":"7ca9d437","chunk-02501173":"28806826","chunk-13581f54":"af09db15","chunk-4dfc6d90":"e2fe94f0","chunk-2d0ae5a4":"31d6cfe0","chunk-35f28bd1":"b39b3b8f","chunk-655795ce":"4fa6f8db","chunk-74916e7f":"3b97817c","chunk-327be9c0":"d757490c","chunk-53ce57c0":"e0188106","course~dashboard":"dcee6d6f","course":"c5f2711e","chunk-9dfabe94":"c3e3a8ed","dashboard":"f79c8386","chunk-531a3eec":"2678b189","chunk-5789a9c2":"31d6cfe0","memoryiq":"6951eb2c","chunk-86ddfb4c":"31d6cfe0","chunk-1cc39b1f":"82fd2155","chunk-29b78bf5":"9f00ac31","chunk-686a04d2":"3baf7168","chunk-9c20f2bc":"3953afbb","chunk-6131bf73":"45a2c7cb","chunk-eb9edea8":"897d3707","chunk-e66db300":"b50d99f9","chunk-063a8ca1":"05a5b563","chunk-6891f6f2":"1d6541f6","chunk-358c8e9a":"f0087293","memogenius-game":"9056f341","chunk-6fa7f4cb":"6d5c1c39","chunk-c030d618":"d59f4f10","chunk-dc5169ec":"fd7972a0","chunk-ecb8ebc4":"d07a1e64","memolanguage":"4356f183","chunk-3bc3fc3d":"e33be772","chunk-4f8cba5a":"066af99c","chunk-04c4f904":"82fd2155","chunk-6d7f4e65":"45a2c7cb","chunk-a9a10d60":"cb1d41ee","chunk-fa134ff0":"9f00ac31","chunk-3b991abb":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/staging/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
